import { makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

interface ILeaveHistory {
  [key: string]: any
}

class LeaveHistory extends Model<ILeaveHistory> {
  static urlRoot() {
    return '/timeoff/leave_histories'
  }

  constructor(attr: ILeaveHistory = {}) {
    super(attr)
    makeObservable(this, {})
  }
}

export default LeaveHistory
